import { Component, OnInit } from '@angular/core';
import { UploadFileService } from 'src/app/services/upload-file.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { faDownload } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-excelupload',
  templateUrl: './excelupload.component.html',
  styleUrls: ['./excelupload.component.css']
})
export class ExceluploadComponent implements OnInit {

  //string
  token: string

  //formData
  uploadForm: FormGroup;
  formData: any;

  //array
  file: Array<any> = [];
  faDownload = faDownload;
  constructor(
    private upload: UploadFileService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private globals: GlobalService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
  }

  onFileSelectF(event) {
    let amount = event.target.files.length
    console.log("Test F: ", event.target.files);
    if (amount > 0 && event.target.files[0]) {
      this.file[0] = event.target.files[0]
      console.log(this.file);

    }
  }

  onFileSelectG(event){
    let amount = event.target.files.length;
    console.log("Test G: ", event.target.files);
    
    if (amount > 0 && event.target.files[0]) {
      this.file[1] = event.target.files[0];
      console.log(this.file);
    }
  }

  uploadFile(){
    console.log("Upload init");
    
    this.uploadForm.get('profile').setValue(this.file);
      const formData = new FormData();
      console.log("formData creato");
      if(this.file[0] || this.file[1]){
        if(this.file[0]){
          formData.append('filepf', this.file[0], this.file[0].name);
        }
        if(this.file[1]){
          formData.append('filepg', this.file[1], this.file[1].name);
        }
       
      
      console.log("Campoi inseriti");
      console.log('Form Data: ', formData);
      this.upload.uploadCsv(this.token, formData).subscribe(
        res => {
          console.log(res)
          this.close();
        },
        err => { console.error(err) }
      );
      }
      else {
        console.log("Nessun file caricato");
      }
      
  }

  svuota() {
    this.file = null;
    console.log(this.file);

  }

  canceling(){
    this.activeModal.close('cancel')
  }

  close(){
    this.activeModal.close();
  }

  downloadPF(){
    this.upload.downloadPFCsv(this.token).subscribe(
      res => {
        console.log("Risposta: ", res);
        
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'Persone fisiche.csv';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      err => {
        console.error("Errore: ", err);
      }
    )
  }

  downloadPG(){
    this.upload.downloadPGCsv(this.token).subscribe(
      res => {
        console.log("Risposta: ", res);
        
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'Persone giuridiche.csv';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      err => {
        console.error("Errore: ", err);
      }
    )
  }
  

}
